import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DATE_FORMAT } from 'app/shared/constants/input.constants';
import { map } from 'rxjs/operators';
import {ICalendar} from "../../shared/model/calendar.model";
import {SERVER_API_URL} from "../../app.constants";
import {createRequestOption} from "../../shared/util/request-util";



type EntityResponseType = HttpResponse<ICalendar>;
type EntityArrayResponseType = HttpResponse<ICalendar[]>;

@Injectable({ providedIn: 'root' })
export class CalendarService {
  public resourceUrl = SERVER_API_URL + 'api/calendar';

  constructor(protected http: HttpClient) {}

  create(calendar: ICalendar): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(calendar);
    return this.http
      .post<ICalendar>(this.resourceUrl, copy, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(calendar: ICalendar): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(calendar);
    return this.http
      .put<ICalendar>(this.resourceUrl, copy, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<ICalendar>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<ICalendar[]>(this.resourceUrl, { params: options, observe: 'response' })
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  protected convertDateFromClient(calendar: ICalendar): ICalendar {
    const copy: ICalendar = Object.assign({}, calendar, {
      // dateOfBirth: calendar.dateOfBirth != null && calendar.dateOfBirth.isValid() ? calendar.dateOfBirth.format(DATE_FORMAT) : null
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.dateOfBirth = res.body.dateOfBirth != null ? moment(res.body.dateOfBirth) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((calendar: ICalendar) => {
        // calendar.dateOfBirth = calendar.dateOfBirth != null ? moment(calendar.dateOfBirth) : null;
      });
    }
    return res;
  }


  getCurrentDate(): Observable<EntityResponseType> {
    const options = createRequestOption();
    return this.http.get<any>(SERVER_API_URL   + 'api/current-date', {params: options, observe: 'response'});
  }

}
